
/*
 * @Author: soji
 * @Description: 餐品工具类
 * @Date: 2021-04-14 17:24:03
 */

import specialUtil from './specialUtil.js';
import COM from './common';

const computePrice = (price)=> COM.computePrice(price,2);


let amendHelp = {

  /**
   * @param {Object} store 将下单门店
   * @param {Object} info 用户输入
   * @param {Object} order 订单
   * @param {Object} originStore 原订单门店
   * @returns {Object} {pass, tips}
   */
  checkSelectStore(store, info, order, originStore) {
    let pass = true, tips = '';
    
    const checkInfo = function() {
      if(!info.phone) {
        pass = false; tips = '请填写收货人电话';
      }else if(!info.name) {
        pass = false; tips = '请填写收货人姓名';
      }else if(!info.sendType) {
        pass = false; tips = '请选择业务类型';
      }else if(info.sendType !== 2 && !info.address) {
        pass = false; tips = '请选择地址';
      }
    }
    // 检查各业务类型的时间是否合规  // 订单业务类型，1-外卖、2-自取、3-堂食、4-外卖预约
    const _checkBusinessType = function () {
      /**
       * 预计时间的合法性依赖于前面保证选择的时间一定是正确的。这里不做校验
       */
      let isInStoreServiceTime = store.isServiceTime; // 门店是否在营业时间

      if(info.sendType == 4 || (info.sendType == 2)) {
        if(!isInStoreServiceTime) {
          pass = false; tips = '当前门店不在营业时间';
        }
      }else if(info.sendType == 3) {
        pass = false; tips = '不支持堂食改单';
      }


    }
    const checkStore = function() {
      if(!(store.businessType||[]).includes(info.sendType)) {
        pass = false; tips = '门店不支持当前业务';
      }else if(store.storeId !== originStore.storeId) {
        // 切换门店要检查下单渠道、业务类型
        if(store.isBusy) {
          pass = false; tips = '当前门店繁忙';
        }else{
          _checkBusinessType()
        }
      }
    }

    checkInfo()
    pass && checkStore()

    return {pass, tips};
  },

  installPostOutMenuPros(outMenuPros) {
    // let proFields = {
    //   'groups': null, 
    //   'listRequirements': null,
    //   'getIndex': 0,
    //   'isScore': false,
    //   'num': 1,
    //   'pid': null,
    //   'price': 0,
    //   'remark': '',
    //   'title': '',
    //   'titleEn': '',
    //   'totalMealFee': 0,
    //   'totalPrice': 0,
    //   'totalProductPrice': 0,
    //   'typeId': 0,
    // };
    let postOutMenuPros = [];
    (outMenuPros || []).map(pro => {
      // 原订单的数据覆盖回去【容错餐品接口要求不懂字段】
      if(!pro._pro) {
        console.error('容错餐品在初始化时没有记录下原餐品_pro字段');
      }
      let {price, totalPrice, realTimePrice, realTimeTotalPrice,} = pro._pro
      let postProItem = {...pro, price, totalPrice, realTimePrice, realTimeTotalPrice};

      delete postProItem._pro;

      postProItem.type = pro._originType;
      postProItem.faultTolerantProduct = true;
      // Object.keys(proFields).map(key => {
      //   postProItem[key] = pro[key] || proFields[key];
      // })
      postOutMenuPros.push(postProItem)
    })

    return postOutMenuPros;
  },

  // pros是未合并餐品数组，该函数将返回一个合并的餐品数组
  mergePros(pros) {
    let proMap = new Map();

    pros.map(pro => {
      if(proMap.has(pro.pid)){
        let existPro = proMap.get(pro.pid)
        if(existPro.listRequirements && pro.listRequirements) {
          existPro.listRequirements.push(...pro.listRequirements)
          existPro.num += pro.num;
        }
        if(existPro.groups && pro.groups) {
          existPro.groups.push(...pro.groups)
          existPro.num += pro.num;
        }
      }else {
        proMap.set(pro.pid, pro)
      }
    })

    return Array.from(proMap.values())
  },

  getOutMenuComboProDesc(outMenuPro) {
    let desc = '';

    try {
      let products = [];

      (outMenuPro.groups|| []).map(comboItem => {
        
        let exAreaGroups = comboItem.exArea ? comboItem.exArea.groups || [] : [];
        let mainGroups = [];
  
        (comboItem.mains || []).map(main => {
          mainGroups.push(...main.groups)
        })
  
        let allGroups = [...exAreaGroups, ...mainGroups];
        allGroups.map(group => {
          products.push(...group.products)
        })
    
        if(products.length) {
          products.map(pro => {
            desc += (pro.name + (` * ${pro.num }`))
            if(pro.listPropertys && pro.listPropertys.length) {
              desc += '（';
              (pro.listPropertys || []).map(per => {
                (per.propertys || []).map(realPerItem => {
                  (realPerItem.items || []).map(item => {
                    desc += (item.name + (item.num > 1 ? ` * ${item.num}` : '') + '、')
                  })
                })
              })
              desc += '）'
            }
            desc += '<br>'
          })
        }
      })


      
    } catch (error) {
      console.error('getOutMenuProDesc:',error);
    }


    return desc;
  },

  // 算特殊要求的单价
  countRequirementItemSinglePriceFromOrder(listRequirementItem, pro) {
    let price = pro.realTimePrice;
    (listRequirementItem.propertys || []).map(pty => {
      (pty.items || []).map(item => {
        price += computePrice(item.num * item.realTimePrice)
      })
    })
    return price
  },

  // 算套餐的单价
  countComboItemSinglePriceFromOrder(groupItem, pro, priceField = 'realTimePrice') {


      let price = pro[priceField];
    
      try {
          let products = [];
          let exAreaGroups = groupItem.exArea ? groupItem.exArea.groups || [] : [];
          let mainGroups = [];
    
          (groupItem.mains || []).map(main => {
            mainGroups.push(...main.groups)
          })
    
          let allGroups = [...exAreaGroups, ...mainGroups];
          allGroups.map(group => {
            products.push(...group.products)
          })
      
          if(products.length) {
            products.map(pro => {
              price += computePrice(pro.num * pro[priceField])
            })
          }
  
  
        
      } catch (error) {
        console.error('算错套餐的单价:',error);
      }
  
  
      return price;
  },

  // orderData有两种格式，一种是展开的，一种是包含的
  /**
   * typeId -1 表示赠送餐品。 todo:优化公共部分代码
   */
  getOutMenuProsFromOrderPros(orderPros) {
    console.log("生成容错餐品", orderPros);
    let outMenuPros = [];

    // 将有容错标记的 餐品/特殊要求/套餐子餐品 模拟成一个单品无特殊要求子餐品添加到outMenuPros
    for(let i = 0; i < orderPros.length; i++) {
      let pro = orderPros[i];

      // 餐品是容错则挪到新数组
      // 餐品外壳有容错标记，则需要将特殊要求、套餐展开再加入到新数组
      if(pro.faultTolerantProduct && pro.typeId !== -1) { // 这里模拟容错
        
        if(pro.listRequirements && pro.listRequirements.length) {
          for(let j = 0; j < pro.listRequirements.length; j++) {
            let requirement = pro.listRequirements[j]
            let singlePrice = this.countRequirementItemSinglePriceFromOrder(requirement, pro);
            if(requirement.typeId !== -1) {
              outMenuPros.push(
                {
                  ...pro,
                  _pro: pro,
                  outMenu: true, 
                  num: requirement.num, 
                  oldNum: requirement.num,
                  totalProductPrice: singlePrice * requirement.num, // 该份总价
                  stockNum: 99999,
                  title: pro.name,
                  _originType: pro.type,
                  type: 1,
                  _remarkVisible: false,
                  _remark: '',
                  _key: pro.pid + '-' + requirement.index,
                  price: singlePrice,
                  listRequirements: [requirement],
                  originInfo: `原订单数量${requirement.num} 单价${singlePrice}`,
                }
              );
  
              pro.num -= requirement.num;
              pro.listRequirements.splice(j ,1);
              pro.hasMove = true;
              --j;
            }
          }
        }else if(pro.groups && pro.groups.length) {
          for(let j = 0; j < pro.groups.length; j++) {
            let requirement = pro.groups[j]
            let singlePrice = this.countComboItemSinglePriceFromOrder(requirement, pro);
            if(requirement.typeId !== -1) {
              outMenuPros.push(
                {
                  ...pro,
                  _pro: pro, 
                  outMenu: true,
                  num: requirement.num, 
                  oldNum: requirement.num,
                  totalProductPrice: singlePrice * requirement.num, // 该份总价
                  stockNum: 99999,
                  title: pro.name,
                  _originType: pro.type,
                  type: 1,
                  _remarkVisible: false,
                  _remark: '',
                  _key: pro.pid + '-' + requirement.index,
                  price: singlePrice,
                  groups: [requirement],
                  originInfo: `原订单数量${requirement.num} 单价${singlePrice}`,
                }
              );
  
              pro.num -= requirement.num;
              pro.groups.splice(j ,1);
              pro.hasMove = true;
              --j;
            }
          }
        }else {
          outMenuPros.push(
            {
              ...pro, 
              _pro: pro,
              outMenu: true,
              oldNum: pro.num,
              totalProductPrice: pro.realTimePrice * pro.num, // 该份总价
              price: pro.realTimePrice,
              stockNum: 99999,
              title: pro.name,
              _originType: pro.type,
              type: 1,
              _remarkVisible: false,
              _remark: '',
              _key: pro.pid + '-' + pro.pid,
              listRequirements: null,
              groups: null,
              originInfo: `原订单数量${pro.num} 单价${pro.realTimePrice}`,
            }
          );
        }
        
        orderPros.splice(i ,1)
        pro.hasMove = true;
        i--;
      }else if(pro.listRequirements && pro.listRequirements.length && pro.typeId !== -1) {
        for(let j = 0; j < pro.listRequirements.length; j++) {
          let requirement = pro.listRequirements[j]
          let singlePrice = this.countRequirementItemSinglePriceFromOrder(requirement, pro);
          if(requirement.faultTolerantProduct && requirement.typeId !== -1) {
            outMenuPros.push(
              {
                ...pro, 
                _pro: pro,
                outMenu: true,
                num: requirement.num, 
                oldNum: requirement.num,
                totalProductPrice: singlePrice * requirement.num, // 该份总价
                stockNum: 99999,
                title: pro.name,
                _originType: pro.type,
                type: 1,
                _remarkVisible: false,
                _remark: '',
                _key: pro.pid + '-' + requirement.index,
                price: singlePrice,
                listRequirements: [requirement],
                originInfo: `原订单数量${requirement.num} 单价${singlePrice}`,
              }
            );

            pro.num -= requirement.num;
            pro.listRequirements.splice(j ,1);
            pro.hasMove = true;
            --j;
          }
        }
      }
      else if(pro.groups && pro.groups.length && pro.typeId !== -1) {
        for(let j = 0; j < pro.groups.length; j++) {
          let requirement = pro.groups[j]
          let singlePrice = this.countComboItemSinglePriceFromOrder(requirement, pro);
          if(requirement.faultTolerantProduct && requirement.typeId !== -1) {
            outMenuPros.push(
              {
                ...pro,
                _pro: pro, 
                outMenu: true,
                num: requirement.num, 
                oldNum: requirement.num,
                totalProductPrice: singlePrice * requirement.num, // 该份总价
                stockNum: 99999,
                title: pro.name,
                _originType: pro.type,
                type: 1,
                _remarkVisible: false,
                _remark: '',
                _key: pro.pid + '-' + requirement.index,
                price: singlePrice,
                groups: [requirement],
                originInfo: `原订单数量${requirement.num} 单价${singlePrice}`,
              }
            );

            pro.num -= requirement.num;
            pro.groups.splice(j ,1);
            pro.hasMove = true;
            --j;
          }
        }
      }
    }

    // 特殊要求、套餐如果被挪空了，就去掉该餐品
    for(let i = 0; i < orderPros.length; i++) {
      let pro = orderPros[i];
      // 有被挪过才判断是否未空壳
      if(pro.hasMove) {
        if(pro.listRequirements && !pro.listRequirements.length) {
          orderPros.splice(i ,1);
          i--;
        }else if(pro.groups && !pro.groups.length) {
          orderPros.splice(i ,1);
          i--;
        }
      }
    }

    return outMenuPros;
  },

  /**
   * @param {Object} outMenuPro 不在餐单的餐品
   * @returns {Array} 将容错餐品转成单品。特殊要求、套餐需要展开多个单品 
   */
  getCartProsFromOutMenuPro(outMenuPro) {
    let pros = [];
    // 特殊要求 拆成 无特殊要求单品
    if(outMenuPro.listRequirements) {
      outMenuPro.listRequirements.forEach(requirement => {
        let singlePrice = 0; // 单价
        singlePrice += requirement.num * outMenuPro.price; // 外壳金额
        singlePrice += requirement.num * requirement.price; // 特殊要求金额
        pros.push(
          {
            ...outMenuPro, 
            num: requirement.num,
            oldNum: requirement.num,
            totalProductPrice: singlePrice * requirement.num, // 该份总价
            stockNum: 99999,
            title: outMenuPro.name,
            _originType: outMenuPro.type,
            type: 1,
            _remarkVisible: false,
            _remark: '',
            _key: outMenuPro.pid + '-' + requirement.index,
            price: singlePrice,
            childList: requirement.listRequirements,
            listRequirements: [],
          })
      });
    }
    // 套餐
    if(outMenuPro.groups) {

    }
    return pros;
  },

  // 计算容错餐品的价格
  countProductFee(cartPros) {
     let fee = 0;
    cartPros.forEach(pro => {
      fee += pro.totalProductPrice;
    });
     return computePrice(fee);
  },

  // 计算容错餐品的价格
  countProductCount(cartPros) {
     let count = 0;
    cartPros.forEach(pro => {
      count += pro.num;
    });
     return computePrice(count);
  },

  // 计算容错餐品的餐盒费
  countMealFee(cartPros) {
     let fee = 0;
    cartPros.forEach(pro => {
      fee += computePrice((pro.mealFee || 0) * pro.num);
    });
     return computePrice(fee);
  },

  _getProsByProductGroup(productGroup) {
    let menuProChildPros = []; // 套餐餐品包含的子餐品集合

    let loopGroupX = function(groupX, field, isMain = true) {
      if(!groupX) return

      if(['groupA', 'groupB'].includes(field)){
        groupX.cells.map(cell => {
          cell.groupType = groupX.type;
          cell.groupName = groupX.title;
          cell.isMain = isMain;
        })
        menuProChildPros.push(...groupX.cells);
      }else if(['groupC', 'groupD'].includes(field)) {
        (groupX.items || []).map(item => {
          item.cells.map(cell => {
            cell.groupType = groupX.type;
            cell.groupName = groupX.title;
            cell.isMain = isMain;
          })
          menuProChildPros.push(...item.cells,);
        })
      }

    };

    let extFoodArea = productGroup.extFoodArea || {}; // extFoodArea: {groupB groupC groupD}
    let groupFields = ['groupA', 'groupB', 'groupC', 'groupD'];
    groupFields.map(field => {
      loopGroupX(extFoodArea[field], field, false);
    })

    let mains = productGroup.mainFoodAreas || [];
    mains.map(main => {
      let groupFields = ['groupA', 'groupB', 'groupC', 'groupD'];
      groupFields.map(field => {
        loopGroupX(main[field], field, true);
      })

      if(main.associatedGroups){
        Object.values(main.associatedGroups).map(group => {
          groupFields.map(field => {
            loopGroupX(group[field], field, true);
          })
        })
      }

    })
    return menuProChildPros;
  },


  _getProsByOrderComboPros(orderComboPro) {
    let childPros = []; // 套餐餐品包含的子餐品集合

    let loopGroup = function(group, groupIdx, isMain = true) {
      if(!group) return

      group.products.map((cell,cellIdx) => {
        cell.groupType = group.type;
        cell.groupName = group.name;
        cell.groupIdx = groupIdx;
        cell._proKey = cell.pid + groupIdx + cellIdx;
        cell.isMain = isMain;
      })
      childPros.push(...group.products,);

    };

    if(orderComboPro.groups) {
      orderComboPro.groups.map(group => {

        let exArea = group.exArea || {};
        (exArea.groups || []).map((group,groupIdx) => {
          loopGroup(group, groupIdx, false);
        })

        let mains = group.mains || [];
        mains.map(main => {
          main.groups.map((group,groupIdx) => {
            loopGroup(group, groupIdx, true);
          })
        })


      })
    }

    return childPros;
  },



  // 餐单的套餐子餐品板块类型覆盖掉订单的板块类型【因为第三方订单不返回板块类型，接口固定写死type=2】
  recoverOrderFromProductGroup(productGroup, orderPros, pid) {
    // let orderPros = JSON.parse(JSON.stringify(orderProList))
    let menuProChildPros = this._getProsByProductGroup(productGroup);
    menuProChildPros.sort((a, b) => {
      if (a.isMain && !b.isMain) return -1;
      if (a.isMain && b.isMain && a.type === 2 && b.type !== 2) return -1;
      if (a.isMain && b.isMain && a.type === 4 && b.type !== 4) return -1;
      return 0;
    });

    let isNormalPro = function(menuPro, orderPro) {
      return  menuPro.pid === orderPro.pid && menuPro.isMain === orderPro.isMain && menuPro.groupType === orderPro.groupType
    }


    // 处理范围：订单套餐餐品在餐单中相对应板块匹配不到的餐品。把这些餐品从原板块 根据餐单的板块 放到合适的板块位置。
    console.log('-----------', orderPros);

    let orderComboPros = orderPros.filter(pro => pro.pid == pid)
    orderComboPros.map(orderPro => {
      let orderProChildPros = this._getProsByOrderComboPros(orderPro, true);

      // 在餐单中匹配不到的子餐品集合
      let cantMatchChildPros = [] ;

      for (let i = 0; i < orderProChildPros.length; i++) {
        let orderChildPro = orderProChildPros[i];
        if(!menuProChildPros.some(menuPro => isNormalPro(menuPro, orderChildPro))) {
          let cantMatchPro = orderProChildPros.splice(i, 1)[0]

          // 移除订单数据的无法匹配餐单的套餐子餐品, 由cantMatchChildPros重新将被移除的餐品根据餐单重新插入订单数据
          if(orderPro.groups) {
            let proGroup = orderPro.groups[0];
            let block = cantMatchPro.isMain ? (proGroup.mains ? proGroup.mains[0] : null) : proGroup.exArea;
            if(block && block.groups) {
              let childGroup = block.groups[cantMatchPro.groupIdx]
              if(childGroup && childGroup.products) {
                let index = childGroup.products.findIndex(pro => pro._proKey === cantMatchPro._proKey)
                if(index >= 0) childGroup.products.splice(index, 1)
              }
            }
          }

          cantMatchChildPros.push(cantMatchPro)
          i--;
        }
      }

      console.log('找不到匹配的子餐品:', cantMatchChildPros)

      let moveOrderChildProToCorrectPosition = function (matchMenuPro, cantMatchPro, orderPro) {
        if(!orderPro.groups || !orderPro.groups[0]) {return console.error('订单餐品返回的套餐结构有问题：没有返回正确的groups')};
        let proGroup = orderPro.groups[0]  

        if(matchMenuPro.isMain) {

          if(!proGroup.mains || !proGroup.mains.length) {
            proGroup.mains = [
              {
                editType: 0,
                groups: [],
                mid: 0,
                name: '主食区',
              }
            ]
          }

          let groups = proGroup.mains[0] ? proGroup.mains[0].groups : [];
          let group = groups.find(group => group.type == matchMenuPro.groupType);
          if(!group) {
            groups.push({
              editType: 0,
              gid: 0,
              index: groups.length,
              name: matchMenuPro.groupName,
              products: [{...cantMatchPro}],
              type: matchMenuPro.groupType,
            })
          }else {
            group.products.push({...cantMatchPro})
          }

        }else {

          if(!proGroup.exArea) {
            proGroup.exArea = {
              editType: 0,
              groups: [],
              name: '副食区',
            }
          }

          let groups = proGroup.exArea.groups || [];
          let group = groups.find(group => group.type == matchMenuPro.groupType);
          if(!group) {
            groups.push({
              editType: 0,
              gid: 0,
              index: groups.length,
              name: matchMenuPro.groupName,
              products: [{...cantMatchPro}],
              type: matchMenuPro.groupType,
            })
          }else {
            group.products.push({...cantMatchPro})
          }
          
        }

      }

      for (let i = 0; i < cantMatchChildPros.length; i++) {
        const cantMatchPro = cantMatchChildPros[i];
        let matchMenuPro = menuProChildPros.find(orderPro => orderPro.pid == cantMatchPro.pid)
        if(matchMenuPro) {
          moveOrderChildProToCorrectPosition(matchMenuPro, cantMatchPro, orderPro)
        }
      }

    })

    return orderPros

  },

  // 订单套餐价格覆盖掉餐单套餐价格
  recoverProductGroupFromOrder(productGroup, orderPros) {
    let menuProChildPros = this._getProsByProductGroup(productGroup)

    if(orderPros && orderPros.length) {
       // 匹配到订单外壳餐品
      let matchOrderProduct = orderPros.find(orderPro => orderPro.pid == productGroup.pid && orderPro.pid > 0 && orderPro.typeId !== -1);

      if(matchOrderProduct && matchOrderProduct.products) {
        // 餐品价格覆盖
        productGroup.price = matchOrderProduct.realTimePrice;

        // 订单餐品的特殊要求items
        let matchOrderProRefItems = [];
        (matchOrderProduct.products || []).map(orderComboChildPro => {
          // 订单的套餐子餐品  匹配到 餐单套餐子餐品
          let matchMenuProChildPro = menuProChildPros.find(menuProChildPro => menuProChildPro.pid == orderComboChildPro.pid)

          if(matchMenuProChildPro) {
            console.log('找到覆盖套餐子餐品...', matchMenuProChildPro, orderComboChildPro);
            // 餐品-子餐品价格覆盖
            matchMenuProChildPro.price = orderComboChildPro.realTimePrice;

            // 遍历特殊要求
            let orderComboChildProReqItems = specialUtil.getListRequirementsItems(orderComboChildPro); // 订单套餐餐品子餐品的特殊要求
            let menuProChildProReqItems = specialUtil.getProductGroupProRequirementItems(matchMenuProChildPro);// 餐单套餐餐品子餐品的特殊要求
            (orderComboChildProReqItems || []).map(itemFromOrder => {
              let matchItemFromMenu = menuProChildProReqItems.find(itemFromMenu => itemFromMenu.uid == itemFromOrder.uid)
              if(matchItemFromMenu) {
                console.log('找到覆盖套餐子餐品特殊要求...', matchItemFromMenu, itemFromOrder);
                // 餐品-子餐品-特殊要求覆盖
                matchItemFromMenu.price = itemFromOrder.realTimePrice;
              }
            });
          }

        })
        

      

      }

    }


  },

  isSamePro(pro1 , pro2) {
    if(pro1.pid > 0 && pro2.pid > 0 && pro1.pid == pro2.pid) {
      return true
    }
    if(pro1.pid <= 0 && pro2.pid <= 0 && pro1.name == pro2.name) {
      return true
    }
    return false
  },

  //orderProducts 订单详情接口中 orderProducts 必须是原接口中展开的结构。 tips：orderProducts结构、字段跟orderProductOwn是不同的
  // 菜单的套餐外壳金额在这里该，但是里层的子餐品这里改不了。因为不在getProductMenu接口中返回，而是通过getProductGroup。所以等
  // getProductGroup接口回来，需要再覆盖子餐品金额
  recoverMenuPriceFromOrder(menus, orderPros) {

    console.log('餐单覆盖...');
    
    let menuProducts = [];
    (menus.bigs || []).map(big => {
      if(Array.isArray(big.smalls)) {
        (big.smalls || []).map(small => {
          menuProducts.push(...small.products)
        })
      }else {
        menuProducts.push(...big.products)
      }
    })

    menuProducts.map(menuPro => {
      (orderPros || []).map(orderPro => {
        let matchOrderPro = null;
        if(this.isSamePro(orderPro, menuPro) && orderPro.typeId !== -1) {
          matchOrderPro = orderPro;
        }
        if(matchOrderPro) {
  
          // 餐品外壳价格覆盖
          menuPro.price = matchOrderPro.realTimePrice;
  
          console.log('有匹配到需要覆盖的餐品：',matchOrderPro)
  
          // 特殊要求价格覆盖
          if(menuPro.isRequirement && matchOrderPro.listRequirements) {
  
            let orderProReqUidMap = new Map(); // 记录原订单餐品的特殊要求 uid-特殊要求项
            // specialUtil.loopSpecialItems(matchOrderPro, item => {
            //   orderProReqUidMap.set(item.uid, item)
            // }, false)
            specialUtil.getListRequirementsItems(matchOrderPro).map(item => {
              orderProReqUidMap.set(item.uid, item)
            })
  
            specialUtil.loopSpecialItems(menuPro, item => {
              let matchOrderProReqItem = orderProReqUidMap.get(item.uid); // 匹配到原订单餐品的特殊要求项
              console.log('有匹配到需要覆盖的特殊要求：',matchOrderProReqItem)
              if(matchOrderProReqItem) {
                item.price = matchOrderProReqItem.realTimePrice;
              }
            }, false)
          }
  

  
  
          
        }
      })

    })

  },

  deepClone (target, hash = new WeakMap()) { // 额外开辟一个存储空间WeakMap来存储当前对象
    if (target === null) return target // 如果是 null 就不进行拷贝操作
    if (target instanceof Date) return new Date(target) // 处理日期
    if (target instanceof RegExp) return new RegExp(target) // 处理正则
    if (target instanceof HTMLElement) return target // 处理 DOM元素
  
    if (typeof target !== 'object') return target // 处理原始类型和函数 不需要深拷贝，直接返回
  
    // 是引用类型的话就要进行深拷贝
    if (hash.get(target)) return hash.get(target) // 当需要拷贝当前对象时，先去存储空间中找，如果有的话直接返回
    const cloneTarget = new target.constructor() // 创建一个新的克隆对象或克隆数组
    hash.set(target, cloneTarget) // 如果存储空间中没有就存进 hash 里
  
    Reflect.ownKeys(target).forEach(key => { // 引入 Reflect.ownKeys，处理 Symbol 作为键名的情况
      cloneTarget[key] = this.deepClone(target[key], hash) // 递归拷贝每一层
    })
    return cloneTarget // 返回克隆的对象
  },



}





export default amendHelp;


// WEBPACK FOOTER //
// ./../../plugins/utils/amendHelp.js